export default {"src":"https://web.cdn.greenlight.com/2.1355.0/_next/static/media/angle-left.c9027dcc.svg","height":28,"width":13,"blurWidth":0,"blurHeight":0};